// extracted by mini-css-extract-plugin
module.exports = {"animatedText":"style_animatedText__EnJFC","css-wozli0-Typography-root":"style_css-wozli0-Typography-root__fwege"};